import { render, staticRenderFns } from "./gender.vue?vue&type=template&id=8e7c145a&scoped=true"
import script from "./gender.vue?vue&type=script&lang=js"
export * from "./gender.vue?vue&type=script&lang=js"
import style0 from "./gender.vue?vue&type=style&index=0&id=8e7c145a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7c145a",
  null
  
)

export default component.exports